<template>
  <v-card flat>
    <v-card-text>
      <v-row
        justify="space-between"
      >
        <v-col cols="auto">
          <v-card width="256">
            <v-navigation-drawer permanent>
              <v-list
                dense
                rounded
              >
                <v-list-item
                  v-for="platform in platforms"
                  :key="platform.id"
                  link
                  :to="'/charts/' + platform.name"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ platform.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </v-col>
        <v-col>
          <div
            v-if="!$route.params.platform"
            class="title font-weight-light grey--text pa-4 text-center"
          >
            Select platform
          </div>
          <router-view />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    platforms() {
      return this.$store.state.platforms;
    }
  },
}
</script>